import { Component } from '@angular/core';
import { ListComponent } from 'src/app/common/component/list.component';

@Component({
	selector: 'app-reservations-people-list',
	templateUrl: './reservations-people-list.component.html',
	styleUrls: ['./reservations-people-list.component.css'],
})
export class ReservationsPeopleListComponent extends ListComponent {
	protected apiUrl = 'resident/reservationsPeopleList';

	tableRows = [
		{ id: 'destination', name: 'Destynacja' },
		{ id: 'reservationNumber', name: 'Rezerwacja (Wycieczka)' },
		{ id: 'firstName', name: 'Imię' },
		{ id: 'lastName', name: 'Nazwisko' },
		{ id: 'phone', name: 'Numer Telefonu' },
	];

	protected loadBefore() {
		this.filters = {
			id: this.route.snapshot.params['id'],
			date: this.route.snapshot.params['date'],
		};
		this.loadData();
	}

	print() {
		window.print();
	}
}
